<template>
	<!-- Vertical layout -->
	<!-- (This is the main layout that is likely to become the final one). -->
	<div class="wrapper">
		<Sidebar
			:is-condensed="isMenuCondensed"
			:theme="leftSidebarTheme"
			:type="leftSidebarType"
		/>
		<div class="content-page">
			<div class="content">
				<div class="navbar-custom">
					<Topbar :user="currentUser" layout="vertical" />
				</div>
				<DeliveryOverview />
				<div class="container-fluid">
					<slot />
				</div>
			</div>
			<Footer :app-env="appEnv" />
		</div>
		<RightSidebar />
	</div>
</template>

<script>
import { authComputed, layoutComputed, layoutMethods } from '@/store/helpers'
import router from '@/router'
import Topbar from '@/components/Topbar.vue'
import Sidebar from '@/components/Sidebar.vue'
import RightSidebar from '@/components/RightSidebar.vue'
import Footer from '@/components/Footer.vue'
import DeliveryOverview from '@/components/DeliveryOverview.vue'

const { VUE_APP_ENV } = process.env

export default {
	components: { Topbar, Sidebar, RightSidebar, Footer, DeliveryOverview },
	data() {
		return {
			isMenuCondensed: false,
			appEnv: VUE_APP_ENV
		}
	},
	computed: {
		...authComputed,
		...layoutComputed
	},
	watch: {
		layoutWidth(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.activateWidth(newVal)
			}
		}
	},
	created: function () {
		document.body.classList.remove('authentication-bg')
		document.body.classList.remove('authentication-bg-pattern')
		document.body.removeAttribute('data-layout')
		if (window.screen.width >= 767 && window.screen.width <= 1028) {
			this.changeLeftSidebarType({ leftSidebarType: 'condensed' })
			this.isMenuCondensed = true
		} else if (window.screen.width > 1028) {
			this.changeLeftSidebarType({ leftSidebarType: 'fixed' })
			this.isMenuCondensed = false
		}
		this.activateWidth(this.layoutWidth)
	},
	mounted: () => {
		// TODO: ...
		if (
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
				navigator.userAgent
			)
		) {
			if (window.screen.width >= 728 && window.screen.width <= 1028) {
				document.body.setAttribute(
					'data-leftbar-compact-mode',
					'condensed'
				)
			}
		}
		if (
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
				navigator.userAgent
			)
		) {
			router.afterEach((routeTo, routeFrom) => {
				document.body.classList.remove('sidebar-enable')
			})
		}
	},
	methods: {
		...layoutMethods,
		toggleMenu() {
			document.body.classList.toggle('sidebar-enable')
		},
		hideMenu() {
			document.body.classList.remove('sidebar-enable')
		},
		toggleRightSidebar() {
			document.body.classList.toggle('right-bar-enabled')
		},
		hideRightSidebar() {
			document.body.classList.remove('right-bar-enabled')
		},
		activateWidth(width) {
			switch (width) {
				case 'boxed':
					document.body.setAttribute('data-layout-mode', 'boxed')
					this.changeLeftSidebarType({ leftSidebarType: 'condensed' })
					this.isMenuCondensed = true
					break
				default:
					document.body.removeAttribute('data-layout-mode')
					this.changeLeftSidebarType({ leftSidebarType: 'fixed' })
					this.isMenuCondensed = false
					break
			}
		}
	}
}
</script>
